<template>
    <div>
        <Tab name="1"></Tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="视频ID" :value="2"></el-option>
                            <el-option label="视频名称" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.display" placeholder="请选择" size="small">
                        <el-option label="仅看显示的" :value="1"></el-option>
                        <el-option label="仅看隐藏的" :value="0"></el-option>
                        <el-option label="不限制状态" value=""></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.type" placeholder="请选择" size="small">
                        <el-option label="不限制视频类型" value=""></el-option>
                        <el-option label="仅看MV的" :value="1"></el-option>
                        <el-option label="仅看Vlog的" :value="2"></el-option>
                        <el-option label="仅看Live现场的" :value="3"></el-option>
                        <el-option label="仅看Fan拍的" :value="4"></el-option>
                        <el-option label="仅看其他的" :value="9"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示最新上传的" :value="1"></el-option>
                        <el-option label="优先展示播放次数最多的" :value="2"></el-option>
                        <el-option label="优先展示半播次数最多的" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.styleType" placeholder="请选择" size="small" @change="params.tag='';params.style='',params.channel=''">
                        <el-option label="音乐风格分类" :value="1"></el-option>
                        <el-option label="音乐风格" :value="2"></el-option>
                        <el-option label="所属频道" :value="3"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-if="params.styleType == 1" v-model="params.style" placeholder="请选择音乐风格分类" size="small">
                        <el-option v-for="(item,index) in styleList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <el-cascader v-if="params.styleType == 2" v-model="params.tag" :options="tagList" :props="{value:'id',label:'name',children:'tags',emitPath:false}" size="small" style="width:100%"></el-cascader>
                    <el-input v-if="params.styleType == 3" v-model="params.channel" placeholder="请输入频道名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="上传时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div v-if="$utils.have('/video/sortList')" class="page-btns-box">
            <el-button type="primary" icon="el-icon-sort" @click="$refs.videoSort.show()" size="small">精选视频排序</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="userName" label="用户名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="id" label="视频ID"></el-table-column>
                <el-table-column prop="pic" label="视频封面">
                    <template slot-scope="scope"><el-image :src="scope.row.pic | coverImage(400,225)" fit="cover" :preview-src-list="[scope.row.pic]"></el-image></template>
                </el-table-column>
                <el-table-column prop="name" label="视频名称" min-width="120" show-overflow-tooltip></el-table-column>
                <el-table-column prop="type" label="类型" show-overflow-tooltip>
                    <template slot-scope="scope">{{types.get(scope.row.type)}}</template>
                </el-table-column>
                <el-table-column prop="styleTags" label="风格" show-overflow-tooltip></el-table-column>
                <el-table-column prop="time" label="时长"></el-table-column>
                <el-table-column prop="clickNum" label="播放次数"></el-table-column>
                <el-table-column prop="playNum" label="半播次数"></el-table-column>
                <el-table-column prop="createTime" label="上传时间" min-width="150"></el-table-column>
                <el-table-column prop="display" label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.display == 1" type="success" size="mini">显示</el-tag>
                        <el-tag v-else type="info" size="mini">隐藏</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="channel" label="所属频道" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/video/update')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="$utils.have('/video/play')"
                            type="text"
                            size="small"
                            icon="el-icon-video-play"
                            @click="play(scope.row)"
                            >播放</el-button
                        >
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-link"
                            @click="$refs.videoCopy.show(scope.row)"
                            >复制</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <video-edit ref="videoEdit" @onUpdate="getDataList()"></video-edit>
        <video-sort ref="videoSort" @onUpdate="getDataList()"></video-sort>
        <!-- <el-dialog 
            :visible.sync="playVideoVisible" 
            title="视频播放" 
            center 
            append-to-body 
            :close-on-click-modal="false" 
            @close="tcPlayer.destroy()" 
            id="play-box">
            <div class="preview-box">
                <div class="video-container" id="video-container"></div>
            </div>
        </el-dialog> -->
        <VideoPlay ref="videoPlay"></VideoPlay>
        <VideoCopy ref="videoCopy"></VideoCopy>
    </div>
</template>

<script>
import VideoEdit from './components/video-edit';
import VideoSort from './components/video-sort';
import {fetchStyleList,fetchAllTag} from '@/assets/js/commonApi';
import VideoPlay from "@/components/VideoPlay";
import VideoCopy from "@/components/VideoCopy";

import Tab from '../components/tab';
const defaultParams = {
    pageNo: 1,
    queryType:1,
    queryValue:'',
    styleType:1,
    style:'',
    tag:'',
    timeType:1,
    startTime:'',
    endTime:'',
    display:1,
    type:'',
    sort:1,
    channel:''
}
export default {
    components:{
        VideoEdit,Tab,VideoSort,VideoPlay,VideoCopy
    },
    data() {
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
            listLoading: false, 
            datetimerange:[],
            styleList:[],
            tagList:[],
        };
    },
    computed:{
        types(){
            return new Map([
                [1,'MV'],[2,'Vlog'],[3,'Live现场'],[4,'Fan拍'],[9,'其他']
            ])
        }
    },
    mounted(){
        this.getStyleList();
        this.getTagList();
        this.getDataList();
    },
    methods: {
        getStyleList(){
            fetchStyleList().then( res => {
                const { state, result } = res.data;
                if(state == 1){
                    this.styleList = result || [];
                }
            })
        },
        getTagList(){
            fetchAllTag().then( res => {
                const { state, result } = res.data;
                if(state == 1){
                    this.tagList = result || [];
                }
            })
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/video/getPageList",
                method: "POST",
                data: {
                    ...this.params,
                    startTime:this.datetimerange && this.datetimerange[0] || null,
                    endTime:this.datetimerange && this.datetimerange[1] || null
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //编辑事件
        edit(id){
            this.$refs.videoEdit.show(id);
        },
        play(data){
			this.$refs.videoPlay.show(data);          
        },
    },
};
</script>